import React from "react";
import { Drawer, Form, Input, Button, Switch, DatePicker, Space, Tooltip } from "antd";
import { EditOutlined, InfoCircleOutlined, PlusOutlined } from "@ant-design/icons";

interface DrawerWithFormProps {
  form: any;
  openDrawer: () => void;
  closeDrawer: () => void;
  isOpen: boolean;
  type: string;
  onSubmit: (values: any) => void;
  submitting: boolean;
  buttonLabel: string;
  hasPermissions: boolean;
}

const CostCodeForm: React.FC<DrawerWithFormProps> = ({
  form,
  openDrawer,
  closeDrawer,
  isOpen,
  type,
  onSubmit,
  submitting,
  buttonLabel,
  hasPermissions
}) => {
  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      onSubmit(values);
    } catch (error) {
      console.error("Validation Failed:", error);
    }
  };

  return (
    <>
      <Button
        type="primary"
        icon={buttonLabel === "Edit" ? <EditOutlined /> : <PlusOutlined />}
        className="action-btn"
        onClick={openDrawer}
        disabled={!hasPermissions}
      >
        {buttonLabel === "Edit" ? "Edit" : "Add Cost Code"}
      </Button>

      <Drawer
        title={`${type} Cost Code`}
        open={isOpen}
        onClose={closeDrawer}
        className="manage-pages-drawer"
      >
        <Form form={form} layout="horizontal" autoComplete="off">
          <Form.Item
            name="code"
            label="Cost Code"
             rules={[
            {
              validator: (_, value) => {
                if (!value || value.trim() === "") {
                  return Promise.reject("Please type cost code title.");
                }
                if (value.startsWith(" ")) {
                  return Promise.reject("Please type valid cost code title. Cannot start with a space.");
                }
                return Promise.resolve();
              },
            },
            ]}
          >
            <Input style={{ width: 250 }} placeholder="Ex: GGL_CGLATO_038" />
          </Form.Item>

          <Form.Item
            name="validFrom"
            label={
              <Space>
                Valid From
                <Tooltip title="Applies to projects received on or after this date — codes change by financial year, so a new year's code can be entered ahead of time with its date and the cost-code rules pick the code in date. Leave empty for a code that applies from the beginning.">
                  <InfoCircleOutlined style={{ color: "var(--primary-color)" }} />
                </Tooltip>
              </Space>
            }
          >
            <DatePicker style={{ width: 250 }} placeholder="From the beginning" format="DD MMM YYYY" />
          </Form.Item>

          <Form.Item name="isActive" label="Active" valuePropName="checked">
            <Switch defaultChecked={true} />
          </Form.Item>
        </Form>
        <div style={{ textAlign: "right" }}>
          <Button onClick={closeDrawer} style={{ marginRight: 8 }}>
            Cancel
          </Button>
          <Button type="primary" onClick={handleSubmit} loading={submitting}>
            Submit
          </Button>
        </div>
      </Drawer>
    </>
  );
};

export default CostCodeForm;
